// extracted by mini-css-extract-plugin
export default {"Radish":"#C20026","inputError":"G6e957f G558e8c"};